import * as React from 'react';

import { EnrollmentFormWrapper } from './EnrollmentFormWrapper';

class Header extends React.Component<any, any> {

  public render() {
    return (
      <EnrollmentFormWrapper>
        <header className="main-header">
          <div className="logo">
            <a href={this.props.url}>
              <img src="/d3rest/v4/themes/images/LOGO" height="95" width="450" style={{maxHeight: '100%', width:'auto'}}/>
            </a>
          </div>
        </header>
        <div className="spacer" />
      </EnrollmentFormWrapper>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.tsx